export default __webpack_public_path__ + "static/media/gallery.e53a8a83.svg";